import commonJSON from '@config/common/pl.json'
import { namespaces } from '@lib/localisation/config'

export const PLConfig = {
  common: commonJSON
} as const satisfies Record<(typeof namespaces)[number], unknown>
